import React from 'react';
import APP_ICONS from './appIcons';

export const APP_ICON_NAMES = Object.keys(APP_ICONS);
export const hasAppIcon = (name) => !!APP_ICONS[name];

// One icon from the app's outline set (appIcons.js), drawn as the app draws
// it: stroked in the current text colour
const AppIcon = ({ name, size = 24, className = '' }) => {
  const markup = APP_ICONS[name];
  if (!markup) {
    return null;
  }
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      // Our own generated markup, not user input
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
};

export default AppIcon;
